export default function mapNamesToSubtestIds(uA) {
  let output = {}
  const subtests = Object.values(uA.assessmentSubtests)
  subtests.forEach(subtest => {
    output[subtest.displayName] = subtest.setId
  })
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/mapNamesToSubtestIds.js